import _toConsumableArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { reducer } from "../reduce";
export function str(sep, xs) {
  sep = sep || "";
  var first = true;
  return xs ? _toConsumableArray(xs).join(sep) : reducer(function () {
    return "";
  }, function (acc, x) {
    return acc = first ? acc + x : acc + sep + x, first = false, acc;
  });
}